import { render } from "./help.vue?vue&type=template&id=ebe521aa"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
script.render = render

export default script